module.exports = __webpack_public_path__ + "static/media/01.269c71f6.jpg";